export default [
  { 
    path: '/job', 
    name: 'JobAnnouncement', 
    component: () => import('@/views/job/Announcement'),
    meta: {
      breadcrumbs: [
        { text: 'ประกาศรับสมัครงาน', disabled: true }
      ]
    }
  },
  {
    path: '/job/new',
    name: 'JobNew',
    component: () => import('@/views/job/Form'),
    meta: {
      form_type: 'NEW', 
      form_title: 'เพิ่ม',
      breadcrumbs: [
        { text: 'ประกาศรับสมัครงาน', to: '/job' },
        { text: 'เพิ่มประกาศ', disabled: true  }
      ],
    }
  },
  {
    path: '/job/:id/edit',
    name: 'JobEdit',
    component: () => import('@/views/job/Form'),
    meta: {
      form_type: 'EDIT', 
      form_title: 'แก้ไข',
      breadcrumbs: [
        { text: 'ประกาศรับสมัครงาน', to: '/job' },
        { text: 'แก้ไขประกาศ', disabled: true  }
      ],
    }
  }
]